/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



    /**
 * Fáze zpracování importu/aktualizace
 * @export
 * @enum {string}
 */

export const JsonImportPhase = {
    /**
    * Import záznamů
    */
    DATA: 'DATA',
    /**
    * Načítání obrázků
    */
    IMAGES: 'IMAGES',
    /**
    * Dokončeno
    */
    DONE: 'DONE'
} as const;

export type JsonImportPhase = typeof JsonImportPhase[keyof typeof JsonImportPhase];



